export var KeySellingPointsMode;
(function (KeySellingPointsMode) {
    KeySellingPointsMode["Regular"] = "regular";
    KeySellingPointsMode["Short"] = "short";
})(KeySellingPointsMode || (KeySellingPointsMode = {}));
